export const SHIPPING_CONSTANTS = {
  SHIPPING_ADDRESS_NAME_PREFIX: 'Shipping_',
};

export const CHECKOUT_IDS = {
  CONTACT_FORM: 'contact-form',
  SHIPPING_ADDRESS_FORM: 'shipping-address-form',
  BILLING_ADDRESS_FORM: 'billing-address-form',
  SHIPPING_METHOD_FORM: 'shipping-method-form',
};
